import { THEME_ID, ThemeProvider } from '@mui/material/styles';
import * as React from 'react';
import { bowtieCjkTheme, bowtieTheme, createBrandTheme } from './bowtieTheme';
import { jsx as _jsx } from "react/jsx-runtime";
const scopedTheme = {
  [THEME_ID]: bowtieTheme
};
const scopedCjkTheme = {
  [THEME_ID]: bowtieCjkTheme
};
const scopedBrandThemes = new Map();
const getScopedTheme = (isCjk, brand) => {
  if (!brand) return isCjk ? scopedCjkTheme : scopedTheme;
  const key = JSON.stringify([isCjk, brand]);
  let scopedBrandTheme = scopedBrandThemes.get(key);
  if (!scopedBrandTheme) {
    scopedBrandTheme = {
      [THEME_ID]: createBrandTheme(brand, isCjk)
    };
    scopedBrandThemes.set(key, scopedBrandTheme);
  }
  return scopedBrandTheme;
};
const BowtieThemeProvider = ({
  children,
  lang = 'en',
  brand
}) => _jsx(ThemeProvider, {
  theme: getScopedTheme(lang.includes('zh'), brand),
  children: children
});
export default BowtieThemeProvider;